import { WifiMarkerIcon } from './WifiMarkerIcon';

/**
 * author: Colton Wiscombe
 * id A6FB83C2-13FE-4B23-AE9B-7F2696CA2835
 * name wifi-marker
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wifi-marker.svg
 * tags
 * - Navigation 
 */
export const WifiLocationIcon = WifiMarkerIcon;
export default WifiLocationIcon